import type { VendorDefinition } from "../types";

/** Statistics vendors. Domains feed the blocklist; the metadata feeds the disclosure table. */
export const ANALYTICS_VENDORS: VendorDefinition[] = [
  {
    id: "google-analytics",
    name: "Google Analytics 4",
    provider: "Google Ireland Ltd.",
    category: "analytics",
    purpose: {
      de: "Zählt Seitenaufrufe, Verweildauer und Herkunft der Besucher, um zu erkennen, welche Inhalte gefunden und genutzt werden.",
      en: "Counts page views, time on page and traffic sources to show which content is found and used.",
    },
    domains: ["google-analytics.com", "analytics.google.com", "googletagmanager.com"],
    cookies: [
      { name: "_ga*", retention: { de: "2 Jahre", en: "2 years" } },
      { name: "_gid", retention: { de: "24 Stunden", en: "24 hours" } },
      { name: "_gat*", retention: { de: "1 Minute", en: "1 minute" } },
    ],
    usTransfer: true,
    privacyUrl: "https://policies.google.com/privacy",
  },
  {
    id: "google-tag-manager",
    name: "Google Tag Manager",
    provider: "Google Ireland Ltd.",
    category: "analytics",
    purpose: {
      de: "Lädt und verwaltet die übrigen Mess- und Marketing-Tags dieser Website.",
      en: "Loads and manages the other measurement and marketing tags on this site.",
    },
    domains: ["googletagmanager.com", "tagmanager.google.com"],
    cookies: [],
    usTransfer: true,
    privacyUrl: "https://policies.google.com/privacy",
  },
  {
    id: "hotjar",
    name: "Hotjar",
    provider: "Hotjar Ltd. (Malta)",
    category: "analytics",
    purpose: {
      de: "Zeichnet Mausbewegungen, Klicks und Scrollverhalten auf und erstellt daraus Heatmaps und Sitzungsaufzeichnungen.",
      en: "Records mouse movement, clicks and scrolling to build heatmaps and session recordings.",
    },
    domains: ["hotjar.com", "hotjar.io"],
    cookies: [{ name: "_hj*", retention: { de: "bis zu 1 Jahr", en: "up to 1 year" } }],
    // Erring toward disclosure: over-disclosing a transfer is never a violation,
    // under-disclosing one is. Verify against your own DPA before launch.
    usTransfer: true,
    privacyUrl: "https://www.hotjar.com/legal/policies/privacy/",
  },
  {
    id: "posthog",
    name: "PostHog",
    provider: "PostHog Inc.",
    category: "analytics",
    purpose: {
      de: "Erfasst Produkt-Ereignisse wie Klicks und Seitenwechsel, um Nutzungsverläufe und Funnels auszuwerten.",
      en: "Captures product events such as clicks and page changes to analyse usage flows and funnels.",
    },
    domains: ["posthog.com", "i.posthog.com", "posthog.io"],
    cookies: [{ name: "ph_*", retention: { de: "1 Jahr", en: "1 year" } }],
    usTransfer: true,
    privacyUrl: "https://posthog.com/privacy",
  },
  {
    id: "microsoft-clarity",
    name: "Microsoft Clarity",
    provider: "Microsoft Ireland Operations Ltd.",
    category: "analytics",
    purpose: {
      de: "Zeichnet Sitzungen auf und erstellt Heatmaps, um Bedienprobleme auf der Website zu finden.",
      en: "Records sessions and builds heatmaps to find usability problems on the site.",
    },
    domains: ["clarity.ms"],
    cookies: [{ name: "_clck", retention: { de: "1 Jahr", en: "1 year" } }],
    usTransfer: true,
    privacyUrl: "https://privacy.microsoft.com/privacystatement",
    strictOnly: true,
  },
  {
    id: "matomo",
    name: "Matomo Cloud",
    provider: "InnoCraft Ltd. (Neuseeland)",
    category: "analytics",
    purpose: {
      de: "Zählt Seitenaufrufe und Herkunft der Besucher. Kann datenschutzfreundlich ohne Cookies betrieben werden.",
      en: "Counts page views and traffic sources. Can be run without cookies in a privacy-friendly setup.",
    },
    domains: ["matomo.cloud", "matomo.org"],
    cookies: [{ name: "_pk_*", retention: { de: "13 Monate", en: "13 months" } }],
    usTransfer: false,
    privacyUrl: "https://matomo.org/privacy-policy/",
    strictOnly: true,
  },
  {
    id: "plausible",
    name: "Plausible Analytics",
    provider: "Plausible Insights OÜ (Estland)",
    category: "analytics",
    purpose: {
      de: "Zählt Seitenaufrufe ohne Cookies und ohne personenbezogene Daten. In vielen Konstellationen einwilligungsfrei einsetzbar.",
      en: "Counts page views without cookies or personal data. Often usable without consent.",
    },
    domains: ["plausible.io"],
    cookies: [],
    usTransfer: false,
    privacyUrl: "https://plausible.io/privacy",
    strictOnly: true,
  },
];
